<template>
  <div class="single-vehicle-cost">
    <m-title />
    <div class="page-content">
      <div class="config block">
        <div class="dot"></div>
        <div class="title">当前配置</div>
        <div class="ctx-wrap">
          <span class="itm">载重定义开始时间：<b class="val">
            {{ cur_config.fahuodi_feikongcheStart }}
          </b> </span>
          <span class="itm">载重定义结束时间：<b class="val">{{ cur_config.fawangdi_feikongcheEnd }}</b> </span>
          <span class="itm">空车定义开始时间：<b class="val">{{ cur_config.fahuodi_kongcheStart }}</b> </span>
          <span class="itm">空车定义结束时间：<b class="val">{{ cur_config.fawangdi_kongcheEnd }}</b> </span> 
        </div>
        <div class="btn-wrap">
          <el-button @click="cost_dlg_config.show = true" class="primary-btn" size="medium">配置</el-button>
          <el-button class="default-btn" size="medium" @click="fn_config_reset">重置</el-button>
        </div>

      </div>

      <div class="query block">
        <el-form inline class="my-el-form" label-width="60px">
          <el-form-item label="计划号">
            <el-input v-model="query.pno" placeholder="输入计划号" />
          </el-form-item>
          <el-form-item label="车队">
            <el-input v-model="query.fleetname" placeholder="车队" />
          </el-form-item>
          <el-form-item label="车牌号">
            <el-input v-model="query.plate" placeholder="车牌号" />
          </el-form-item>

          <el-form-item label="船名">
            <el-input v-model="query.shipname" placeholder="船名" />
          </el-form-item>

          <el-form-item label="流向">
            <el-select v-model="liuxiang">
              <el-option label='港俊到前沿' value="港俊到前沿" />
              <el-option label='前沿到港俊' value="前沿到港俊" />
            </el-select>
          </el-form-item>

          <el-form-item label="货类">
            <el-input v-model="query.cargoname" placeholder="货类" />
          </el-form-item>

          <el-form-item label="日期">
            <el-date-picker class="my-date-picker" value-format="yyyy-MM-dd" v-model="date_range" type="daterange"
              start-placeholder="开始日期" end-placeholder="结束日期" />
          </el-form-item>

        </el-form>
        <div class="btn-wrap">
          <el-button class="primary-btn" size="medium"
            @click="pagination.currengPage = 1, get_average_single_car_cost_data(), get_single_car_cost_data()">查询</el-button>
          <el-button class="default-btn" size="medium" @click="fn_query_reset">重置</el-button>
        </div>
      </div>
      <div class="average-single-vehicle-cost-well block" v-loading="isloading">
        <div class="title">
          <span class="dot"></span>
          <span>平均单车成本</span>
          <span class="tips">
            注:数据统计为 港俊
            <i class="el-icon-right" />
            前沿(约5.2公里路程)，前沿
            <i class="el-icon-right" />
            港俊(约9.4公里路程)。
          </span>
        </div>
        <div class="context">
          <div class="item" :style="{ '--w': block.length }" v-for="(block, idx) in average_block_cfg">
            <item-cost v-for="it in block" :key="it" v-bind="average[it]" />
          </div>
        </div>
      </div>

      <div class="table-single-vehicle-cost block">
        <div class="title">
          <span class="dot" />
          <span>单车成本</span>
          <button-group class="btn-box">
            <el-button size="mini" :class="[type == 2 ? 'primary-btn' : 'default-btn']" @click="type = 2">载重</el-button>
            <el-button size="mini" :class="[type == 1 ? 'primary-btn' : 'default-btn']" @click="type = 1">空车</el-button>
          </button-group>
        </div>
        <div class="content">
          <el-table :data="single_cost" border stripe fit v-loading="table_loading">
            <el-table-column v-for="(it, idx) in table_fields" :key="idx" v-bind="it" />
          </el-table>
          <div class="table-ext">
            <div class="summary-box">
              <span>共 <b>{{ total }}</b> 条数据 </span>
              <span>平均单车成本：<b>{{ avgPrice }}</b> </span>
            </div>

            <el-pagination v-bind="pagination" @current-change="fn_pagination_current_change" />
          </div>

        </div>

      </div>
    </div>
    <cost-config-dlg v-if="cost_dlg_config.show" v-bind="{ ...cost_dlg_config, query }"
      @close="cost_dlg_config.show = false" @success="fn_dlg_success" />
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import itemCost from './item-cost'
import { ButtonGroup } from 'element-ui'
import costConfigDlg from './cost-config-dlg'

const item_config = {
  comprehensiveAveragePreTonCost: { label: '综合平均单车单吨成本', unit: '元/吨', tips: '计算公式：综合平均单车成本➗平均载重吨数 = 综合平均单车单吨成本' },
  loadAveragePreTonCost: { label: '载重平均单车单吨成本', unit: '元/吨', tips: '计算公式：载重平均单车成本➗平均载重吨数 = 载重平均单车单吨成本' },
  comprehensiveAveragePreCarCost: { label: '综合平均单车成本', unit: '元', tips: '计算公式：载重平均单车成本 ＋ 空车平均单车成本 = 综合平均单车成本' },
  loadAveragePreCarCost: { label: '载重平均单车成本', unit: '元', tips: '计算公式：载重平均单车消耗电量 ✖ 平均电价 = 载重平均单车成本' },
  preEmptyCarAverageCost: { label: '空车平均单车成本', unit: '元', tips: '计算公式：空车平均单车消耗电量 ✖ 平均电价 = 空车平均单车成本' },
  averageElecPrice: { label: '平均电价', unit: '元/度', tips: '计算公式：总的充电金额 ➗ 总的充电度数 = 平均电价' },
  loadAverageTon: { label: '平均载重吨数', unit: '吨', tips: '计算公式：累计载重吨数 ➗ 载重车次 = 平均载重吨数' },
  loadAverageElectricity: { label: '载重平均单车耗电量', unit: '度', tips: '<p style="min-width:280px;">计算公式：<p>载重定义开始时间时单车的剩余电量 － 载重定义结束时间时单车的剩余电量 = 单车载重消耗电量百分比<p> 载重空车消耗电量百分比 ✖ 该车电池容量=单车载重消耗电量 <p> 累计单车载重消耗电量➗载重车次 = 载重平均单车耗电量' },
  emptyCarAverageElectricity: { label: '空车平均单车耗电量', unit: '度', tips: '<p style="min-width:340px;">计算公式：<p>空车定义开始时间时单车的剩余电量 － 空车定义结束时间时单车的剩余电量 = 单车空车消耗电量百分比<p>  单车空车消耗电量百分比 ✖ 该车电池容量=单车空车消耗电量<p> 累计单车空车消耗电量➗空车车次 = 空车平均单车耗电量' },
}

const items = {
  fahuodi:[
    { label: '发货地进卡口时间', value: 'in' },
    { label: '发货地回皮时间', value: 'huipi' },
    { label: '发货地过重时间', value: 'guozhong' },
    { label: '发货地出卡口时间', value: 'out' }
  ],
  fawangdi:[
    { label: '发往地进卡口时间', value: 'in' },
    { label: '发往地回皮时间', value: 'huipi' },
    { label: '发往地过重时间', value: 'guozhong' },
    { label: '发往地出卡口时间', value: 'out' }
  ]
}


export default {
  components: { mTitle, itemCost, ButtonGroup, costConfigDlg },
  data() {
    return {
      // 总数据条数
      total: 0,
      // 平均单车成本
      avgPrice: 0,
      //单车成本
      single_cost: [],
      //平均单车成本
      average_cost: {
        "comprehensiveAveragePreTonCost": 0,
        "loadAveragePreTonCost": 0,
        "comprehensiveAveragePreCarCost": 0,
        "loadAveragePreCarCost": 0,
        "preEmptyCarAverageCost": 0,
        "averageElecPrice": 0,
        "loadAverageTon": 0,
        "loadAverageElectricity": 0,
        "emptyCarAverageElectricity": 0
      },
      isloading: false,
      table_loading: false,
      type: 2, //1-空车，2-非空车
      average_block_cfg: [
        ['comprehensiveAveragePreTonCost', 'loadAveragePreTonCost'],
        ["comprehensiveAveragePreCarCost", "loadAveragePreCarCost", "preEmptyCarAverageCost",],
        ["averageElecPrice", "loadAverageTon", "loadAverageElectricity", "emptyCarAverageElectricity"],
      ],
      cost_dlg_config: {
        items,
        show: false,
        query: this.query
      },
      pagination: {
        currengPage: 1,
        pageSize: 20,
        total: 0,
        class: "pagination",
        layout: "prev,pager,next,->,total"
      },
      query: {
        feikongcheStart: 'huipi',
        feikongcheEnd: 'out',
        kongcheStart: 'in',
        kongcheEnd: 'huipi',
        pno: '',
        fleetname: '',
        plate: '',
        shipname: '',
        source: '港俊',
        destination: '前沿',
        cargoname: '',
        startTime: '',
        endTime: '',
      },
    }
  },
  computed: {
    date_range: {
      get() {
        return [this.query.startTime, this.query.endTime]
      },
      set(val) {
        const [start, end] = val || []
        this.query.startTime = start + " 00:00:00"
        this.query.endTime = end + " 23:59:59"
      }
    },
    liuxiang: {
      get() {
        return this.query.source + '到' + this.query.destination
      },
      set(val) {
        const arr = val.split('到')
        if (arr.length > 0) {
          this.query.source = arr[0]
          this.query.destination = arr[1]
        }
      }
    },
    average() {
      const _this = this
      return new Proxy(item_config, {
        get(obj, key, proxy) {
          const value = _this.average_cost[key]
          return { ...obj[key], value }
        }
      })
    },
    table_fields() {
      const _this = this
      const type = this.type
      const type1 = [
        {
          prop: "startTime", label: "港俊时间", formatter(_row, _col, val) {
            return _this.mydateFormat(val)
          }, width: 160
        },
        { prop: "startTimeSoc", label: "港俊剩余电量", width: 110 },
      ]
      const type2 = [
        {
          prop: "endTime", label: "前沿时间", formatter(_row, _col, val) {
            return _this.mydateFormat(val)
          }, width: 160
        },
        { prop: "endTimeSoc", label: "前沿剩余电量", width: 110 },
      ]
      return [
        { type: 'index', label: '序号', prop: 'index', width: 60 },
        { prop: "plate", label: "车牌号", width: 100 },
        { prop: "fleetname", label: "车队名称", minWidth: 100, showOverflowTooltip: true },
        { prop: "pno", label: "计划编号", width: 100 },
        // { prop: "customname", label: "货主名称" },
        // { prop: "agentname", label: "代理名称" },
        { prop: "shipname", label: "船名" },
        { prop: "source", label: "发货地" },

        type == 1 ? type2 : type1,
        { prop: "destination", label: "发往地" },
        type == 1 ? type1 : type2,
        {
          prop: "type", label: "是否载重", formatter(row, col, val) {
            const enum_type = {
              1: '空车',
              2: '载重'
            }
            return enum_type[val] || '未知'
          }
        },
        { prop: "suttle", label: "载重吨数" },
        { prop: "usekwh", label: "消耗电量" },
        { prop: "price", label: "电价" },
        { prop: "freight", label: "单车成本" },
      ].flat()
    },
    cur_config() {
      return new Proxy(this.query, {
        get(obj, key) {
          const [k1,k2]=key.split('_')
          const type_items=items[k1]
          const item = type_items.find(it => it.value == obj[k2])
          return item.label
        }
      })
    }
  },
  mounted() {
    this.get_average_single_car_cost_data()
    this.get_single_car_cost_data()
  },
  watch: {
    type() {
      this.get_single_car_cost_data()
    }
  },
  methods: {
    fn_pagination_current_change(page) {
      this.pagination.currengPage = page
      this.get_single_car_cost_data()

    },
    fn_query_reset() {
      const init_config = {
        pno: '',
        fleetname: '',
        plate: '',
        shipname: '',
        source: '港俊',
        destination: '前沿',
        cargoname: '',
        startTime: '',
        endTime: '',
      }
      Object.keys(init_config).forEach(k => {
        this.query[k] = init_config[k]
      })
    },
    fn_config_reset() {
      const init_config = { "feikongcheStart": "in", "feikongcheEnd": "out", "kongcheStart": "in", "kongcheEnd": "out" }
      Object.keys(init_config).forEach(k => {
        this.query[k] = init_config[k]
      })
    },
    fn_dlg_success(cfg) {
      for (const key in cfg) {
        this.query[key] = cfg[key]
      }
      get_average_single_car_cost_data()
      get_single_car_cost_data()

    },
    // 平均单车成本
    async get_average_single_car_cost_data() {
      try {
        this.isloading = true
        const res = await this.$request({
          url: 'replenish/DriverCarPreCost/calculateStatistics',
          method: 'get',
          params: {
            ...this.query
          }
        })
        this.average_cost = res.data;
        if (res.code != 0) {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log('error', error);
      } finally {
        this.isloading = false
      }
    },
    //单车成本
    async get_single_car_cost_data() {
      try {
        this.table_loading = true
        const { source, destination, feikongcheStart, feikongcheEnd, kongcheStart, kongcheEnd, ...params } = this.query
        const { currengPage: page, pageSize: limit } = this.pagination
        const type = this.type
        const res = await this.$request({
          url: 'replenish/DriverCarPreCost/perCarCostList',
          method: 'get',
          params: {
            ...params,
            type, page, limit,
            start: type == 1 ? kongcheStart : feikongcheStart,
            end: type == 1 ? kongcheEnd : feikongcheEnd
          }
        })
        if (res.code != 0) {
          this.$message.error(res.msg)
        }
        this.single_cost = res.data.list;
        this.pagination.total = res.data.total
        this.total = res.total
        this.avgPrice = res.avgPrice || 0;
      } catch (error) {
        console.log('error', error);
      } finally {
        this.table_loading = false
      }
    }
  }
}
</script>
<style lang="scss">
$main_btn_color: #17B6A1;

.single-vehicle-cost {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  .page-content {
    flex: 1;
    overflow: auto;
  }

  .title {
    font-family: PingFang SC;
    font-weight: 700;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0.8px;
  }

  .block {
    border-radius: 8px;
    background-color: white;
    padding: 1rem 1.5rem;
    margin: 1rem 1rem 0;

    &.table-single-vehicle-cost {
      .title {
        display: flex;
        align-items: center;
        column-gap: 10px;

        .btn-box {
          margin-left: auto;
          display: flex;
        }
      }

      .content {
        // max-height: 400px;
        margin-top: 1rem;
        min-height: 4rem;

        .table-ext {
          background-color: $main_btn_color;
          color: white;
          display: flex;
          padding: 0.5rem;
          align-items: center;
          justify-content: space-between;

          .summary-box {
            display: flex;
            column-gap: 1rem;
            font-size: 12px;
          }

          .pagination {
            // margin-left: auto;
            font-size: 18px;
          }
        }
      }
    }

    &.average-single-vehicle-cost-well {
      .title {
        display: flex;
        align-items: center;
        gap: 10px;
        justify-content: flex-start;

        .tips {
          font-size: small;
          align-self: flex-end;
          color: #666;

          .el-icon-right {
            font-weight: bold;
            color: #333;
          }
        }
      }

      .context {
        margin-top: 1rem;
        display: flex;
        gap: 0.5rem;

        .item {
          border: 1px dashed gray;
          flex: var(--w);
          aspect-ratio: calc(var(--w) * 3)/2;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          display: flex;


          &:nth-child(1) {
            background-image: url(../../assets/imgs/icon_zhpj@2x.png);
          }

          &:nth-child(2) {
            background-image: url(../../assets/imgs/pic_dccb@2x.png);
          }

          &:nth-child(3) {
            background-image: url(../../assets/imgs/pic_pjdj@2x.png);
          }
        }
      }
    }

    &.query {
      display: flex;

      .btn-wrap {
        white-space: nowrap;
      }

      .my-el-form {
        flex: 1;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        place-items: center;
      }

      .my-date-picker {
        width: 220px;
        border-radius: 6px;

        i.el-icon-date {
          display: none;
        }
      }
    }

    &.config {
      display: flex;
      align-items: center;
      gap: 10px;

      .ctx-wrap {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        column-gap: 1.5rem;
        row-gap: 0.5rem;
        padding: 0 1.5rem;

        .itm {
          height: 14px;
          font-family: PingFang SC;
          font-weight: bold;
          font-size: 14px;
          font-size: small;
          color: #333;
          line-height: 1.4;

          .val {
            color: #666;
          }
        }

      }


    }

    .primary-btn {
      background-color: $main_btn_color;
      letter-spacing: 2px;
      color: white;

      &:hover {
        background-color: lighten($main_btn_color, 3%);
      }
    }

    .default-btn {
      background-color: white;
      color: $main_btn_color;
      letter-spacing: 2px;

      &:hover {
        $default_color: lighten($main_btn_color, 3%);
        color: $default_color;
        border-color: $default_color;
      }
    }

    .dot {
      display: inline-block;
      width: 12px;
      height: 26px;
      border-radius: 6px;
      background-color: $main_btn_color;
    }



  }
}
</style>